// auto-generated by bin/genVersion.ts
export const VERSION = '1.10.2';
